export default __webpack_public_path__ + "static/media/process-step3.70554877.svg";